import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

export const useNavigationGuard = (isActive) => {
  const history = useHistory();
  const blockedNavigation = useRef(null);
  const isNavigationAllowed = useRef(false);
  const [isDiscardModalVisible, setIsDiscardModalVisible] = useState(false);

  // Browser refresh / tab close
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
    };

    if (isActive) {
      window.addEventListener("beforeunload", handleBeforeUnload);
    }

    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [isActive]);

  // React Router in-app navigation
  const handlePromptMessage = (nextLocation) => {
    if (isNavigationAllowed.current) return true;
    blockedNavigation.current = nextLocation;
    setIsDiscardModalVisible(true);
    return false;
  };

  const handleDiscardConfirm = () => {
    isNavigationAllowed.current = true;
    setIsDiscardModalVisible(false);
    const destination = blockedNavigation.current;
    if (destination) {
      history.push(destination.pathname + destination.search);
    } else {
      history.goBack();
    }
  };

  const handleDiscardCancel = () => {
    setIsDiscardModalVisible(false);
  };

  // Cancel button — show modal if active, otherwise just go back
  const handleCancel = () => {
    if (isActive) {
      blockedNavigation.current = null;
      setIsDiscardModalVisible(true);
    } else {
      history.goBack();
    }
  };

  const allowNavigation = () => {
    isNavigationAllowed.current = true;
  };

  return {
    isDiscardModalVisible,
    handlePromptMessage,
    handleDiscardConfirm,
    handleDiscardCancel,
    handleCancel,
    allowNavigation,
  };
};
